import { motion } from 'framer-motion';
import type { Post } from '../types';
import { Calendar, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface PostCardProps {
  post: Post;
  index?: number;
}

export default function PostCard({ post, index = 0 }: PostCardProps) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="group"
    >
      <Link to={`/posts/${post.id}`}>
        <div className="glass rounded-xl p-6 card-hover h-full">
          <div className="flex items-center space-x-2 text-sm text-pink-300/70 mb-3">
            <Calendar size={14} />
            <span>{post.date}</span>
          </div>
          
          <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-pink-400 transition-colors">
            {post.title}
          </h3>
          
          <p className="text-gray-400 text-sm mb-4 line-clamp-2">
            {post.summary}
          </p>
          
          <div className="flex items-center justify-between">
            <div className="flex flex-wrap gap-2">
              {post.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-2 py-1 text-xs bg-pink-500/20 text-pink-300 rounded-full border border-pink-500/30"
                >
                  {tag}
                </span>
              ))}
            </div>
            
            <span className="flex items-center text-sm text-pink-400 opacity-0 group-hover:opacity-100 transition-opacity">
              阅读更多 <ArrowRight size={16} className="ml-1" />
            </span>
          </div>
        </div>
      </Link>
    </motion.article>
  );
}
